import { Component } from '@angular/core';
import { ViewController, Events } from 'ionic-angular';

@Component({
  selector: 'tablepopoverlayout',
  templateUrl: 'tablepopover-layout.html'
})

export class TablePopoverLayout {

  layout: any;
  headerObj: any;

  groupChecked: boolean = false;
  sumChecked: boolean = false;
  sortChecked: boolean = false;

  sortDown: boolean = false;

  sortPosition: number = 0;
  sortPositionMax: number;

  groupingPosition: number = 0;
  groupingPositionMax: number;

  constructor(
    public viewCtrl: ViewController,
    public events: Events) {
    this.layout = viewCtrl.data.layout;
    this.headerObj = viewCtrl.data.headerObj;

    this.groupChecked = this.layout.groupings.includes(this.headerObj.FieldName);
    this.sumChecked = this.layout.sum.includes(this.headerObj.FieldName);

    if (this.layout.sort != undefined) {
      let sortObj = this.layout.sort.find(element => element.name == this.headerObj.FieldName);
      this.sortPositionMax = this.layout.sort.length - 1;
      if (sortObj != undefined) {
        this.sortChecked = true;
        this.sortDown = sortObj.down;
        this.sortPosition = this.layout.sort.indexOf(sortObj);
      }
    } else {
      this.layout.sort = [];
    }

    this.groupingPositionMax = this.layout.groupings.length - 1;
    if (this.groupChecked) {
      this.groupingPosition = this.layout.groupings.indexOf(this.headerObj.FieldName);
    }
  }

  updateLayout() {
    if (this.layout.groupings.includes(this.headerObj.FieldName) && !this.groupChecked) { // if not checked but in grouping
      this.layout.groupings = this.layout.groupings.filter(element => element != this.headerObj.FieldName); // remove from grouping
    } else if (!this.layout.groupings.includes(this.headerObj.FieldName) && this.groupChecked) { // if checked but not in grouping
      this.layout.groupings.splice(this.groupingPosition, 0, this.headerObj.FieldName);// add to grouping at correct position
    }

    if (this.layout.sum.includes(this.headerObj.FieldName) && !this.sumChecked) { // if not checked but in grouping
      this.layout.sum = this.layout.sum.filter(element => element != this.headerObj.FieldName); // remove from grouping
    } else if (!this.layout.sum.includes(this.headerObj.FieldName) && this.sumChecked) { // if checked but not in grouping
      this.layout.sum.push(this.headerObj.FieldName); // add to grouping
    }

    if (this.layout.sort.find(element => element.name == this.headerObj.FieldName) != undefined && !this.sortChecked) { // if not checked but in sort
      this.layout.sort = this.layout.sort.filter(element => element.name != this.headerObj.FieldName); // remove from sort
    } else if (this.layout.sort.find(element => element.name == this.headerObj.FieldName) == undefined && this.sortChecked) { // if checked but not in sort
      this.layout.sort.splice(this.sortPosition, 0, { name: this.headerObj.FieldName, down: this.sortDown });// add to sort at correct position
    }

    this.sortPositionMax = this.layout.sort.length - 1;
    this.groupingPositionMax = this.layout.groupings.length - 1;

    this.events.publish('table:updateLayout', this.layout);
  }

  updateGroupingPosition() {
    this.layout.groupings = this.layout.groupings.filter(element => element != this.headerObj.FieldName); // remove from grouping
    this.layout.groupings.splice(this.groupingPosition, 0, this.headerObj.FieldName); // insert in correct position
    this.events.publish('table:updateLayout', this.layout);
  }

  updateSortingPosition() {
    this.layout.sort = this.layout.sort.filter(element => element.name != this.headerObj.FieldName); // remove from sort
    this.layout.sort.splice(this.sortPosition, 0, { name: this.headerObj.FieldName, down: this.sortDown }); // insert in correct position
    this.events.publish('table:updateLayout', this.layout);
  }

  flipSortingDirection() {
    this.sortDown = !this.sortDown;
    this.layout.sort = this.layout.sort.filter(element => element.name != this.headerObj.FieldName); // remove from sort
    this.layout.sort.splice(this.sortPosition, 0, { name: this.headerObj.FieldName, down: this.sortDown }); // insert in correct position
    this.events.publish('table:updateLayout', this.layout);
  }

}


// WEBPACK FOOTER //
// ./src/popovers/tablepopover-layout/tablepopover-layout.ts